import React, { useState } from 'react';
import {
  Box,
  Button,
  Flex,
  Heading,
  Input,
  Text,
  useToast,
  FormControl,
  FormLabel,
  Link,
  InputGroup,
  InputLeftElement,
  Container,
  VStack,
  Icon,
  Image,
  Badge
} from '@chakra-ui/react';
import { EmailIcon } from '@chakra-ui/icons';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import axiosInstance from '../services/axiosInstance';
import { FaArrowRight, FaEnvelope } from 'react-icons/fa';
import Header from '../layout/Header';
import Footer from '../layout/Footer';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  const primaryColor = '#F2C919';
  const secondaryColor = '#2C3E50';
  const bgColor = 'gray.50';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await axiosInstance.post('/auth/forgot-password', { email });
      toast({
        title: 'تم إرسال بريد استعادة كلمة المرور',
        description: 'تحقق من بريدك الإلكتروني للحصول على التعليمات.',
        status: 'success',
        duration: 5000,
        isClosable: true,
        position: 'top'
      });
      navigate('/login');
    } catch (error) {
      toast({
        title: 'خطأ',
        description: error.response?.data?.message || "حدث خطأ ما في إرسال الطلب",
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top'
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box minH="100vh" bg={bgColor} dir="rtl">
      <Header />

      <Container maxW="container.md" py={{ base: 12, md: 24 }}>
        <VStack spacing={8} align="center">
          <VStack spacing={4} textAlign="center">
            <Badge bg={primaryColor} color={secondaryColor} px={4} py={1} borderRadius="full" fontSize="sm" fontWeight="800" fontFamily="Cairo, sans-serif">
              استعادة الحساب
            </Badge>
            <Heading fontSize={{ base: '3xl', md: '4xl' }} fontFamily="Cairo, sans-serif" fontWeight="900" color={secondaryColor}>
              نسيت كلمة المرور؟
            </Heading>
            <Text fontSize="lg" fontFamily="Tajawal, sans-serif" color="gray.600" maxW="400px">
              أدخل بريدك الإلكتروني وسنرسل لك تعليمات استعادة الوصول إلى حسابك التعليمي.
            </Text>
          </VStack>

          <Box
            w="full"
            maxW="500px"
            bg="white"
            p={{ base: 8, md: 10 }}
            borderRadius="3xl"
            boxShadow="2xl"
            border="2px solid"
            borderColor="gray.100"
          >
            <form onSubmit={handleSubmit}>
              <VStack spacing={6}>
                <FormControl isRequired>
                  <FormLabel fontFamily="Cairo, sans-serif" fontWeight="700">البريد الإلكتروني</FormLabel>
                  <InputGroup>
                    <InputLeftElement h="60px" pointerEvents="none">
                      <EmailIcon color="gray.400" />
                    </InputLeftElement>
                    <Input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="example@mail.com"
                      bg="gray.50"
                      h="60px"
                      borderRadius="xl"
                      border="2px solid"
                      borderColor="transparent"
                      _focus={{ borderColor: primaryColor, bg: 'white' }}
                      fontFamily="Tajawal, sans-serif"
                    />
                  </InputGroup>
                </FormControl>

                <Button
                  type="submit"
                  bg={primaryColor}
                  color={secondaryColor}
                  w="100%"
                  h="65px"
                  fontSize="xl"
                  fontWeight="900"
                  fontFamily="Cairo, sans-serif"
                  borderRadius="xl"
                  boxShadow="lg"
                  isLoading={isLoading}
                  _hover={{ bg: '#d4b016', transform: 'translateY(-2px)' }}
                  _active={{ transform: 'translateY(0)' }}
                  leftIcon={<Icon as={FaEnvelope} ml={2} />}
                >
                  إرسال الرابط
                </Button>

                <Button
                  as={RouterLink}
                  to="/login"
                  variant="ghost"
                  color="gray.500"
                  fontFamily="Cairo, sans-serif"
                  fontWeight="700"
                  _hover={{ color: primaryColor, bg: 'transparent' }}
                  leftIcon={<Icon as={FaArrowRight} ml={1} />}
                >
                  العودة لتسجيل الدخول
                </Button>
              </VStack>
            </form>
          </Box>
        </VStack>
      </Container>

      <Footer />
    </Box>
  );
};

export default ForgotPasswordPage;
